import { makeRequest } from '../makeRequest';
import { TENANTS, LETTERS } from '../requestResources';

export const updateTenantCountry = payload =>
  makeRequest('PUT', `${TENANTS}/countryCode?countryCode=${payload}`, payload);

export const getTenantCountry = () =>
  makeRequest('GET', `${TENANTS}/countryCode`);
